export enum IOrgWorkingSessionsAnalyticsActivityV2Enum {
  LocalSessionStart = 'OrgWorkingSessionsActivityV2.local_session_start',
  LocalSessionStartDate = 'OrgWorkingSessionsActivityV2.local_session_start_date',
  FocusPercentage = 'OrgWorkingSessionsActivityV2.focusPercentage',
  DigitalIntensity = 'OrgWorkingSessionsActivityV2.digitalIntensity',
  SessionCallDuration = 'OrgWorkingSessionsActivityV2.sessionCallDuration',
  TotalActivityDuration = 'OrgWorkingSessionsActivityV2.totalActivityDuration',
  TotalFocusDuration = 'OrgWorkingSessionsActivityV2.totalFocusDuration',
  TotalSessionCallDuration = 'OrgWorkingSessionsActivityV2.totalSessionCallDuration',
  UserId = 'OrgWorkingSessionsActivityV2.userid',
  CumulativeDailyAverageScreentime = 'OrgWorkingSessionsActivityV2.cumulativeDailyAverageScreentime',
  CumulativeDailyAverageWorkingHours = 'OrgWorkingSessionsActivityV2.cumulativeDailyAverageWorkingHours',
  CumulativeWeeklyAverageScreentime = 'OrgWorkingSessionsActivityV2.cumulativeDailyAverageScreentime',
  CumulativeWeeklyAverageWorkingHours = 'OrgWorkingSessionsActivityV2.cumulativeDailyAverageWorkingHours',
  WeekCount = 'OrgWorkingSessionsActivityV2.weekCount',
  DayCount = 'OrgWorkingSessionsActivityV2.dayCount',
  CallWeekCount = 'OrgWorkingSessionsActivityV2.callWeekCount',
  CallDayCount = 'OrgWorkingSessionsActivityV2.callDayCount',
  WeekDayIndex = 'OrgWorkingSessionsActivityV2.weekday_index',
  TotalDuration = 'OrgWorkingSessionsActivityV2.totalDuration',
}
